import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true, // ✅ sends cookie automatically with every request
});

export default API;